var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:(_vm.name + "__link " + _vm.name + "__link--" + _vm.size),attrs:{"data-testid":"a-link-a-link-cZaiUe","target":_vm.target},on:{"click":_vm._onClick}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }